import AsideSection from '../AsideSection/AsideSection';
import AsideAiNewsContent from './AsideAiNewsContent';

type AsideAiNewsProps = {
  icon?: string;
};

const AsideAiNews = ({ icon }: AsideAiNewsProps) => {
  return (
    <AsideSection title='AI讀新聞' icon={icon}>
      <AsideAiNewsContent />
    </AsideSection>
  );
};

export default AsideAiNews;
